const EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
const DAYS = ['Sunday','Monday','Tuesday','Wednesday','Thrusday', 'Friday','Saturday'];
const MONTHS = ['Jan','Feb','Mar','April','May','June','July','Aug','Sep','Oct','Nov','Dec'];
const LAUNCH_MAILER_RELEASE_DATE = '2022-08-20';

export { EMAIL_REGEX, DAYS, MONTHS, LAUNCH_MAILER_RELEASE_DATE };
